// extracted by mini-css-extract-plugin
module.exports = {"MenuListItem":"MenuListItem","MenuListOverlay":"MenuListOverlay"};